module.exports = __webpack_public_path__ + "img/person-seven.4fa7d601.svg";